import module from 'facturacion/configuracion/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('facturacion.configuracion.conceptos.agregar', {
    url: '',
    data: {title: 'Agregar concepto'},
    views: {
      '@facturacion.configuracion': {
        template: '<facturacion-configuracion-conceptos-editar on-close="$ctrl.onClose($event.details)"></facturacion-configuracion-conceptos-editar>',
        controller: ($scope, $state) => {
          $scope.onClose = (data) => {
            if(data && data.id)
            $state.go('facturacion.configuracion.conceptos', {idConcepto: data.id})
          }
        },
      },
    },
  })
})



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/routes/configuracion/conceptos/agregar.js